import { useContext } from "react";
import { Receipt } from "lucide-react";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import { ContainerFilters, ContainerCards, TableSales, ContainerLegend } from ".";


export default function Main() {

    const { isOpen } = useContext(SidebarContext);


    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">

                    <header className="mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4 animate-fade-in">
                        <div className="space-y-1">
                            <div className="flex items-center gap-2">
                                <span className="h-1.5 w-1.5 rounded-full bg-positive-400 animate-glow-pulse" />
                                <span className="label-overline text-positive-400/80">Tempo real</span>
                            </div>
                            <h1 className="display-2 flex items-center gap-3">
                                Vendas
                                <Receipt className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm">
                                Histórico completo de transações com filtros e métricas consolidadas.
                            </p>
                        </div>
                    </header>

                    <ContainerFilters />
                    <ContainerCards />
                    <TableSales />
                    <ContainerLegend />

                </div>
            </div>
        </div>
    );
}
